<template>
  <div :class="style">
    <div class="h-5 flex items-center" v-if="props.icon">
      <Icon :name="props.icon" class="w-3.5 h-3.5 text-cta-tertiary-outline-icon" />
    </div>
    <div class="flex items-center">
      {{ props.message }}
    </div>
  </div>
</template>
<script setup>
import { computed } from "vue";
import Icon from "./Icon.vue";

const props = defineProps({
  variant: { type: String, default: "info" },
  message: { type: String, required: true },
  icon: { type: String, default: "" },
});

const style = computed(() => {
  let base =
    "px-3 py-1 w-fit font-inter text-always-light text-xxs md:text-sm rounded-full flex gap-2 h-full";

  const style_map = {
    info: "bg-info text-always-light",
    filter: "bg-filter-bg text-strongest",
    error: "bg-error text-strongest",
    exchange: "bg-green-600 text-always-light",
    rollover: "bg-yellow-500 text-always-light",
    "title-transfer": "bg-blue-600 text-always-light",
    conversion: "bg-orange-500 text-always-light",
  };

  const style = style_map[props.variant] || style_map["info"];

  return base + " " + style;
});
</script>
